<template>
    <div>
        <SubHeader :text="$t('pa.t')" :imgUrl="imgUrl" />
        <div class="wrap">
            <div class="form">
                <Form />
            </div>
            <div class="right">
                <div class="title reveal-bottom">
                    {{ $t("pa.c") }}
                </div>
                <div class="wrr">
                    <div class="item reveal-bottom">{{ $t("pa.c1") }}</div>
                    <div
                        class="item has-bg reveal-bottom"
                        :style="{ backgroundImage: 'url(' + anquanUrl + ')' }"
                    >
                        {{ $t("pa.c2") }}
                    </div>
                    <div class="item reveal-bottom">{{ $t("pa.c3") }}</div>
                    <div class="item reveal-bottom">{{ $t("pa.c4") }}</div>
                    <div class="item reveal-bottom">{{ $t("pa.c5") }}</div>
                    <div class="item reveal-bottom">{{ $t("pa.c6") }}</div>
                    <div
                        class="item has-bg reveal-bottom"
                        :style="{ backgroundImage: 'url(' + fenxiUrl + ')' }"
                    >
                        {{ $t("pa.c7") }}
                    </div>
                    <div class="item reveal-bottom">{{ $t("pa.c8") }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/components/SubHeader.vue";
import Form from "./Form";
import initAnimation from "../animation";
export default {
    data() {
        return {
            imgUrl: require("@/assets/images/sub_page_banner_8.jpg"),
            fenxiUrl: require("@/assets/images/fenxi.png"),
            anquanUrl: require("@/assets/images/anquan.png"),
        };
    },
    mounted() {
        setTimeout(initAnimation, 0);
    },
    components: {
        SubHeader,
        Form,
    },
};
</script>
<style scoped>
.wrap {
    width: 1200px;
    margin: 120px auto 160px;
    display: flex;
    justify-content: space-between;
}
.form {
    width: 600px;
}
.right {
    width: 457px;
}
.title {
    font-size: 22px;
    color: #333333;
    letter-spacing: 0;
    line-height: 32px;
    font-weight: bold;
}
.wrr {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    height: 192px;
    margin-top: 40px;
}
.item {
    width: 110px;
    height: 90px;
    background-size: auto 90px;
    background-position: center;
    background-color: #f2f2f2;
    font-size: 14px;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
    display: flex;
    align-items: middle;
    justify-content: center;
    flex-direction: column;
    line-height: 20px;
}
.has-bg {
    color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/Pages/Partner/Partner.vue